export class CardTypeTypeApiModel {
  number: number;

  name: string;

  description: string;
}
